import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 * This component processes the `session_id` returned in the URL fragment by
 * Emergent Auth (https://auth.emergentagent.com), exchanges it for our JWT,
 * then redirects to /profile.
 */
export default function AuthCallback() {
  const nav = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);
  const [err, setErr] = useState(null);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.startsWith("#") ? hash.slice(1) : hash);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setErr("No session_id in URL");
      return;
    }

    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        if (data.token) localStorage.setItem("access_token", data.token);
        await refresh();
        toast.success(`Welcome, ${data.user.name}!`);
        // Clear fragment then navigate
        window.history.replaceState(null, "", window.location.pathname);
        nav("/profile", { replace: true });
      } catch (e) {
        setErr(formatApiError(e));
      }
    })();
  }, []);

  return (
    <div className="container-x py-24 max-w-md text-center">
      {!err ? (
        <>
          <Loader2 className="w-16 h-16 mx-auto text-[#FF5E00] animate-spin mb-6" />
          <h1 className="section-heading mb-4">Signing you in...</h1>
          <p className="text-white/60 font-mono-plex text-xs uppercase tracking-widest">Exchanging Google session</p>
        </>
      ) : (
        <>
          <h1 className="section-heading mb-4">Login Failed</h1>
          <p className="text-red-400 font-mono-plex text-sm">{err}</p>
          <button onClick={() => nav("/login")} className="btn-primary mt-6">Back to Sign In</button>
        </>
      )}
    </div>
  );
}
